import {
  SubmitFormRequestElementResult,
  SubmitFormResponse,
} from '@cash-web/protos/squareup/franklin/app/submit_form.pb'
import { BlockerAction } from '@cash-web/protos/squareup/franklin/blocker_action.pb'
import { ErrorMessage } from '@cash-web/shared-data-access-error'

export async function handleFormAction(
  action: BlockerAction,
  onBlockerAction: (
    action: BlockerAction,
    results?: SubmitFormRequestElementResult[]
  ) => Promise<SubmitFormResponse | null>,
  setError: (message: ErrorMessage) => void,
  clearError: () => void
) {
  const onFormResponse = (response: SubmitFormResponse | null) => {
    const message = response?.response_context?.dialog_message || response?.response_context?.failure_message
    if (message != null && message !== '') {
      setError(message)
    } else {
      clearError()
    }
  }

  const onSubmit = async (data: { [index: number]: SubmitFormRequestElementResult }) => {
    const results: SubmitFormRequestElementResult[] = Object.values(data)
    onFormResponse(await onBlockerAction(action, results))
  }

  return { onFormResponse, onSubmit }
}
